import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CalculatedPosition } from 'lcmm-lib-js';
import { ChartEventService } from 'src/app/service/chart-event.service';
import {
  AbstractChartComponent,
  ExtendedPoint,
} from '../abstract-chart/abstract-chart.component';

@Component({
  selector: 'app-trip-altitude-profile',
  templateUrl: '../abstract-chart/abstract-chart.component.html',
  styleUrls: ['../abstract-chart/abstract-chart.component.scss'],
  standalone: false,
})
export class TripAltitudeProfileComponent extends AbstractChartComponent {
  constructor(
    translateService: TranslateService,
    dialog: MatDialog,
    ces: ChartEventService
  ) {
    super(translateService, dialog, ces);
    this.yLabel = 'TRIPS.ALTITUDE.YLABEL';
    this.chartType = 'time';
  }

  // eslint-disable-next-line class-methods-use-this
  public getData(positions: CalculatedPosition[]): ExtendedPoint[] {
    const chartPoints: ExtendedPoint[] = [];

    positions.forEach((p) => {
      chartPoints.push({
        x: p.dtime,
        y: Math.round(p.altitude),
        t: new Date(p.dtime),
      });
    });
    return chartPoints;
  }
}
